import styled from 'styled-components/macro';

const InputWrapper = styled.div`
  position: relative;
  display: flex;
  color: rgba(255, 255, 255, 0.4);
  transition: color 0.25s ease-out;

  input[type="time"] {
    padding-right: 25px;
  }

  svg {
    position: absolute;
    bottom: 11px;
    right: 0;
  }

  &:hover {
    color: #fff;
  }
`;

export default InputWrapper;
